<script setup lang="ts">
/**
 * The polite live region that names the page after a client-side navigation (rank 49). router/route-focus.ts fills it
 * from the router's afterEach; it is mounted once, in App.vue, so it stays in the document across layouts and is
 * already there before its text changes, which is what makes a screen reader read the change.
 */
import { routeAnnouncement } from "@/router/route-focus";
</script>

<template>
  <p class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ routeAnnouncement }}</p>
</template>
